module.exports = __webpack_public_path__ + "img/daniel.8c6ed49a.jpg";